import axios from "axios";

export default axios.create({
    baseURL: "https://api.battlemile.org"
    // baseURL: "http://127.0.0.1:8081/v1"
    // baseURL: "http://192.168.0.122:8080/v1"
    // baseURL: "https://uapi.battlemile.org"
    // baseUrl: 'http://localhost:8081/v1'
});